export var options = {
  verbose: true,
  commercialLicense: false,
  classNamePrefix: "amcharts-",
  autoSetClassName: false,
  minPolylineStep: 0.5
};